import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amzn-athena-details',
  templateUrl: './help-amzn-athena-details.component.html',
  styleUrls: ['./help-amzn-athena-details.component.scss']
})
export class HelpAmznAthenaDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
